import React from "react";
import { css } from "glamor";
import { CheckCircle2, AlertCircle, AlertTriangle, X } from "lucide-react";

const card = css({
  position: "fixed !important",
  top: "20px !important",
  left: "50% !important",
  right: "auto !important",
  transform: "translateX(-50%) !important",
  zIndex: 9999,
  width: "340px",
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: "10px",
  boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
  padding: "14px 16px",
  display: "flex",
  alignItems: "flex-start",
  gap: "12px",
  fontFamily: "Montserrat, sans-serif",
});

const iconColors = {
  success: "#22c55e",
  error: "#ef4444",
  warning: "#f59e0b",
  default: "#6b7280",
};

function IconByType({ type }) {
  const color = iconColors[type] || iconColors.default;
  if (type === "error") return <AlertCircle size={20} color={color} strokeWidth={2} />;
  if (type === "warning") return <AlertTriangle size={20} color={color} strokeWidth={2} />;
  return <CheckCircle2 size={20} color={color} strokeWidth={2} />;
}

export default function Notifier({ visible, title, message, type, onClickHandler }) {
  if (!visible) return null;
  return (
    <div className={card.toString()}>
      <IconByType type={type} />
      <div style={{ flex: 1 }}>
        {title && (
          <p style={{ margin: 0, fontSize: "13px", fontWeight: 600, color: "#111827", lineHeight: "18px" }}>
            {title}
          </p>
        )}
        {message && (
          <p style={{ margin: "2px 0 0", fontSize: "12px", color: "#6b7280", lineHeight: "16px" }}>
            {message}
          </p>
        )}
      </div>
      {onClickHandler && (
        <button
          type="button"
          onClick={onClickHandler}
          style={{ background: "none", border: "none", cursor: "pointer", padding: 0, color: "#9ca3af", lineHeight: 1 }}
        >
          <X size={14} />
        </button>
      )}
    </div>
  );
}
